import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {_getLocalStore} from '@/lib/storage'
import locale from 'element-ui/lib/locale';
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementCNLocale from 'element-ui/lib/locale/lang/zh-CN'// 简体中文
import elementTWLocale from 'element-ui/lib/locale/lang/zh-TW'// 繁体中文
import enLocale from './en'
import cnLocale from './cn'
import twLocale from './tw'
Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  cn: {
    ...cnLocale,
    ...elementCNLocale
  },
  tw: {
      ...twLocale,
      ...elementTWLocale
  },

}

locale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
const i18n = new VueI18n({
  locale: _getLocalStore('language') || 'cn',
  messages,
  silentTranslationWarn: true
})
export default i18n
